const S4DisabledDrugList = [
  "Armodafinil",
  "APX-Paracetamol",
  "Bromazepam",
  "Clobazam",
  "Clonazepam",
  "Clorazepate",
  "Chlordiazepoxide",
  "Codalgin Forte",
  "Codapane Forte",
  "Codeine 500/30",
  "Comfarol Forte",
  "Diazepam",
  "Dolased Forte Tablets",
  "Gabapentin",
  "Lorazepam",
  "Modafinil",
  "Mersyndol Forte",
  "Mevadol Forte",
  "Oxazepam",
  "Phentermine",
  "Panadeine Forte",
  "Pregabalin",
  "Prodeine Forte",
  "Painstop Day-Time Pain Reliever",
  "Painstop Night-Time Pain Reliever",
  "Paracetamol/Codeine GH 500/30 Tablets",
  "Quetiapine",
  "Rikodeine",
  "Tramadol",
  "Temazepam",
  "Triazolam",
  "Zolpidem",
  "Zopiclone",
  "Nitrazepam",
  "Midazolam"
];

export default S4DisabledDrugList;
